import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import { AppStateType } from '../../reducers'
import { push } from '../../actions/router'
import { getMediaTypes } from '../../actions/mediaTypes'
import { updateMediaTypeGroup } from '../../actions/mediaTypeGroup'
import {
  tranfsormMediaTypesForFormik,
  transformFormDataToSend,
} from '../../services/mediaTypeGroups'
import { AREA_CONSTANTS } from '../../services/auth'
import { selectSortedMediaTypesBySelectedToGroup } from '../../selectors/mediaTypes'
import { selectAreaWritable } from '../../selectors/auth'
import { DetailsTemplate } from '../../layouts'
import { StyledAllTypesTable, StyledForm } from './styled'
import { P, Button, H2, NavigationGuard } from '../../components'
import { MediaTypesTableHead, MediaTypesTableRow } from './MediaTypesTable'

const SelectMediaTypesTabComponent = ({
  mediaTypeGroup,
  list: mediaTypesList,
  isLoading,
  editable,
  dispatch,
}) => {
  useEffect(() => {
    dispatch(getMediaTypes())
  }, [dispatch])

  const initialValues = tranfsormMediaTypesForFormik(
    mediaTypeGroup,
    mediaTypesList
  )

  return !(isLoading || mediaTypeGroup.isLoading) ? (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        dispatch(
          updateMediaTypeGroup({
            ...mediaTypeGroup,
            types: transformFormDataToSend(values, mediaTypesList),
          })
        )
      }}
      render={({ isValid, resetForm, dirty }) => (
        <>
          <StyledForm>
            <DetailsTemplate
              aside={
                <>
                  <H2>Save changes</H2>
                  <P>
                    The changes will take effect on this group only after you
                    hit save.
                  </P>
                  <Button
                    id="add-request"
                    color="primary"
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={!isValid}
                  >
                    Save
                  </Button>
                  <Button
                    id="cancel-button"
                    type="button"
                    fullWidth
                    onClick={() => {
                      resetForm()
                      dispatch(
                        push('/settings/media-type-groups?tab=all-groups')
                      )
                    }}
                  >
                    Cancel
                  </Button>
                </>
              }
            >
              <H2 mb={4}>Select media types to include in this group</H2>
              <StyledAllTypesTable>
                <MediaTypesTableHead />
                <tbody>
                  {mediaTypesList.map((mediaType) => (
                    <MediaTypesTableRow
                      key={mediaType.extension}
                      mediaType={mediaType}
                      editable={editable}
                    />
                  ))}
                </tbody>
              </StyledAllTypesTable>
            </DetailsTemplate>
          </StyledForm>
          <NavigationGuard isBlocking={dirty} />
        </>
      )}
    />
  ) : null
}

const mapStateToProps = (state: AppStateType) => ({
  ...selectSortedMediaTypesBySelectedToGroup(state),
  editable: selectAreaWritable(state, {
    area: AREA_CONSTANTS.SETTINGS_MEDIA_TYPE_GROUP_TYPES,
  }),
})

export const SelectMediaTypesTab = connect(mapStateToProps)(
  SelectMediaTypesTabComponent
)
